export default  {
  bindings: {
    extra: '=',
    title: '@'
  },
  controller: 'extrasSaveController',
  template: require('../views/extras.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/extras.save.component.js